import imgOnPicnicTable from "img/pg_tidepool_tablet_blastquiz.png";
import dtBlastQuiz from "img/dt_blast_quiz.png";

const appData = {
  imgOnPicnicTable: imgOnPicnicTable,
  deskTopImg: dtBlastQuiz
};
export default appData;
